import React from 'react';
import { BookOpenIcon, AwardIcon, UsersIcon, FlaskConicalIcon } from 'lucide-react';
export function AuthorSection() {
  return <section className="w-full py-20 px-6 pt-[30px] pb-[30px]" style={{
    background: 'var(--cream)'
  }} aria-label="La autora" data-id="element-1">
      <div className="max-w-5xl mx-auto" data-id="element-2">
        {/* Header */}
        <div className="text-center mb-[25px]" data-id="element-3">
          <p className="text-sm font-bold tracking-widest uppercase mb-[4px]" style={{
          color: 'var(--gold-dark)'
        }} data-id="element-4">
            👩‍🍳 La Mente Detrás del Método
          </p>
          <h2 className="text-4xl md:text-5xl font-bold" style={{
          color: 'var(--brown)'
        }} data-id="element-5">
            Conoce a la Autora
          </h2>
        </div>

        {/* Author card */}
        <div className="rounded-3xl overflow-hidden shadow-xl mb-12" style={{
        background: 'var(--cream-dark)'
      }} data-id="element-6">
          <div className="grid grid-cols-1 md:grid-cols-3" data-id="element-7">
            {/* Photo placeholder */}
            <div className="flex items-center justify-center min-h-64 md:min-h-full" style={{
            background: 'linear-gradient(135deg, var(--blush-light) 0%, var(--sage-light) 100%)'
          }} data-id="element-8">
              <div className="text-center p-8 pt-[16px] pb-[16px] pl-[16px] pr-[16px]" data-id="element-9">
                <div className="w-80 h-80 rounded-full mx-auto mb-4 overflow-hidden shadow-lg" data-id="element-10">
                  <img src="https://cdn.magicpatterns.com/uploads/xrGnSs4JX5sMxvCiJsMJ9k/heylloyd-image-1772316223671.jpg" alt="Carolina Vega - Repostera Profesional" className="w-full h-full object-cover object-top" data-id="element-11" />
                </div>
              </div>
            </div>

            {/* Bio */}
            <div className="md:col-span-2 p-10 flex flex-col gap-5" data-id="element-12">
              <div data-id="element-13">
                <h3 className="text-3xl font-bold mb-1" style={{
                color: 'var(--brown)',
                fontFamily: 'Playfair Display, serif'
              }} data-id="element-14">
                  Carolina Vega
                </h3>
                <p className="text-sm italic" style={{
                color: 'var(--gold-dark)',
                fontFamily: 'Cormorant Garamond, serif',
                fontSize: '1.05rem'
              }} data-id="element-15">
                  Repostera Profesional | Especialista en Nutrición Aplicada a
                  la Pastelería | Creadora del Método Repostería Zero
                </p>
              </div>

              <p className="leading-relaxed" style={{
              color: 'var(--brown-light)',
              lineHeight: '1.85'
            }} data-id="element-16">
                Me formé como repostera profesional durante{' '}
                <strong style={{
                color: 'var(--brown)'
              }} data-id="element-17">
                  4 años
                </strong>{' '}
                en escuelas de gastronomía. Trabajé en{' '}
                <strong style={{
                color: 'var(--brown)'
              }} data-id="element-18">
                  cocinas profesionales por casi una década
                </strong>
                , desde pequeñas pastelerías artesanales hasta restaurantes de
                cocina de autor.
              </p>
              <p className="leading-relaxed" style={{
              color: 'var(--brown-light)',
              lineHeight: '1.85'
            }} data-id="element-19">
                Cuando mi sobrina fue diagnosticada con celiaquía y vi que
                ninguno de mis conocimientos profesionales servía para hacerle
                un postre que realmente valiera la pena, entendí que había un
                problema enorme que nadie estaba resolviendo bien.
              </p>

              {/* Stats */}
            </div>
          </div>
        </div>

        {/* Credentials table */}
        <div className="mb-12" data-id="element-20">
          <h3 className="text-2xl font-bold mb-6 text-center" style={{
          color: 'var(--brown)'
        }} data-id="element-21">
            📚 Formación y Credenciales
          </h3>
          <div className="rounded-2xl overflow-hidden shadow-md" data-id="element-22">
            <table className="w-full table-elegant" aria-label="Formación y credenciales de la autora" data-id="element-23">
              <thead data-id="element-24">
                <tr data-id="element-25">
                  <th className="px-6 py-4 text-left text-sm" data-id="element-26">Área</th>
                  <th className="px-6 py-4 text-left text-sm" data-id="element-27">Formación</th>
                </tr>
              </thead>
              <tbody style={{
              background: 'var(--cream)'
            }} data-id="element-28">
                <tr data-id="element-29">
                  <td className="px-6 py-4 font-bold" style={{
                  color: 'var(--brown)'
                }} data-id="element-30">
                    Repostería Profesional
                  </td>
                  <td className="px-6 py-4" style={{
                  color: 'var(--brown-light)'
                }} data-id="element-31">
                    4 años de formación en escuela de gastronomía certificada
                  </td>
                </tr>
                <tr style={{
                background: 'var(--cream-dark)'
              }} data-id="element-32">
                  <td className="px-6 py-4 font-bold" style={{
                  color: 'var(--brown)'
                }} data-id="element-33">
                    Pastelería Francesa
                  </td>
                  <td className="px-6 py-4" style={{
                  color: 'var(--brown-light)'
                }} data-id="element-34">
                    Técnicas avanzadas de viennoiserie y entremets
                  </td>
                </tr>
                <tr data-id="element-35">
                  <td className="px-6 py-4 font-bold" style={{
                  color: 'var(--brown)'
                }} data-id="element-36">
                    Nutrición Aplicada
                  </td>
                  <td className="px-6 py-4" style={{
                  color: 'var(--brown-light)'
                }} data-id="element-37">
                    Certificación en alimentación sin gluten y dietas
                    terapéuticas
                  </td>
                </tr>
                <tr style={{
                background: 'var(--cream-dark)'
              }} data-id="element-38">
                  <td className="px-6 py-4 font-bold" style={{
                  color: 'var(--brown)'
                }} data-id="element-39">
                    Cocina Sin Restricciones
                  </td>
                  <td className="px-6 py-4" style={{
                  color: 'var(--brown-light)'
                }} data-id="element-40">
                    Más de 2 años de investigación especializada en repostería
                    libre de gluten, lácteos y azúcar
                  </td>
                </tr>
                <tr data-id="element-41">
                  <td className="px-6 py-4 font-bold" style={{
                  color: 'var(--brown)'
                }} data-id="element-42">
                    Experiencia Práctica
                  </td>
                  <td className="px-6 py-4" style={{
                  color: 'var(--brown-light)'
                }} data-id="element-43">
                    Casi una década en cocinas profesionales de LATAM
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        {/* Testing standard */}
        <div className="rounded-2xl p-10 mb-12 text-center" style={{
        background: 'var(--brown)'
      }} data-id="element-44">
          <FlaskConicalIcon className="w-10 h-10 mx-auto mb-4" style={{
          color: 'var(--gold)'
        }} aria-hidden="true" data-id="element-45" />
          <h3 className="text-2xl font-bold mb-4" style={{
          color: 'var(--gold-light)',
          fontFamily: 'Playfair Display, serif'
        }} data-id="element-46">
            El Estándar de Aprobación
          </h3>
          <p className="text-xl italic leading-relaxed max-w-2xl mx-auto" style={{
          color: 'var(--cream)',
          fontFamily: 'Cormorant Garamond, serif',
          fontSize: '1.3rem'
        }} data-id="element-47">
            "Si alguien que no sabe que es sin gluten lo prueba y no lo nota, la
            receta pasa. Si lo nota, volvemos a trabajar."
          </p>
        </div>

        {/* Colleague quotes */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-48">
          <div className="rounded-2xl p-8" style={{
          background: 'var(--cream-dark)',
          border: '1px solid var(--gold-light)'
        }} data-id="element-49">
            <p className="italic leading-relaxed mb-4" style={{
            color: 'var(--brown-light)',
            fontFamily: 'Cormorant Garamond, serif',
            fontSize: '1.1rem'
          }} data-id="element-50">
              "Lo que hace diferente a este método es que viene de alguien con
              formación técnica real en repostería profesional. No es una receta
              adaptada de internet. Es ciencia de cocina aplicada a
              restricciones reales. Eso no lo hace cualquiera."
            </p>
            <p className="text-sm font-bold" style={{
            color: 'var(--brown)'
          }} data-id="element-51">
              — Chef Instructor de Escuela de Gastronomía
            </p>
          </div>
          <div className="rounded-2xl p-8" style={{
          background: 'var(--cream-dark)',
          border: '1px solid var(--sage-light)'
        }} data-id="element-52">
            <p className="italic leading-relaxed mb-4" style={{
            color: 'var(--brown-light)',
            fontFamily: 'Cormorant Garamond, serif',
            fontSize: '1.1rem'
          }} data-id="element-53">
              "Recomiendo DULCE LIBERTAD a todos mis pacientes con celiaquía y
              diabetes tipo 2 que me preguntan cómo pueden seguir disfrutando
              postres. Es el único recurso en español que combina rigor técnico
              con ingredientes accesibles para toda LATAM."
            </p>
            <p className="text-sm font-bold" style={{
            color: 'var(--brown)'
          }} data-id="element-54">
              — Nutricionista especializada en enfermedades autoinmunes
            </p>
          </div>
        </div>

        {/* Mission */}
        <div className="text-center" data-id="element-55">
          <div className="inline-block rounded-2xl px-10 py-8 max-w-2xl" style={{
          background: 'linear-gradient(135deg, var(--blush-light) 0%, var(--sage-light) 100%)'
        }} data-id="element-56">
            <p className="text-sm font-bold tracking-widest uppercase mb-3" style={{
            color: 'var(--brown-light)'
          }} data-id="element-57">
              🎯 La Misión
            </p>
            <p className="text-xl italic leading-relaxed" style={{
            color: 'var(--brown)',
            fontFamily: 'Cormorant Garamond, serif',
            fontSize: '1.25rem'
          }} data-id="element-58">
              "Mi misión es simple: que ninguna persona en LATAM tenga que
              elegir entre su salud y el placer de compartir un postre con las
              personas que ama. La restricción alimentaria es médica. El sabor
              no tiene por qué serlo."
            </p>
          </div>
        </div>
      </div>
    </section>;
}